/* 일자별보고서 상태관리 */
import {getThisMonth, getToDay} from "../../../common/DateUtils";
import {atom} from "jotai";
import {decimalFormat} from "../../../common/StringUtils";
import {defaultCondition} from "./common";
import {calculateEcpm, formatEcpm} from "./metrics";
import MetricValue from "../../../components/reports/MetricValue";

const formatRevenue = value => Number(value || 0).toLocaleString("ko-KR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const ecpmColumn = {
  name: 'ecpm',
  textAlign: 'end',
  header: 'ECPM',
  sortable: false,
  render: ({data}) => {
    const value = calculateEcpm(data?.revenueAmount, data?.exposureCount);
    return <MetricValue $metric="ecpm" className="won">{formatEcpm(value)}</MetricValue>
  }
};

export const reportsStatics = {
  pageSize: 30,
  currentPage: 1,
  searchStartDate: getThisMonth().startDay,
  searchEndDate: getToDay(),
  productType: null,
  targetingType: null,
  exchangeSearchType: null,
  deviceType: null,
  inventoryId: null,
  agentType: defaultCondition.agentType.map(obj => obj.value),
  sortType: null
}

export const reportsUserStaticsAllColumn = [
  {name: 'historyDate', header: '통계일'},
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="request">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="exposure">{decimalFormat(value)}</MetricValue>
  },
  //{name: 'validClickCount', header: '클릭수',type: 'number', render: ({value}) => <span>{decimalFormat(value)}</span>},
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <MetricValue $metric="revenue" className="won">{formatRevenue(value)}</MetricValue>
  },
  ecpmColumn,
]
/* 일자별보고서 컬럼 */
export const reportsStaticsAllColumn = [
  {name: 'historyDate', header: '통계일'},
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="request">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="exposure">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <MetricValue $metric="revenue" className="won">{formatRevenue(value)}</MetricValue>
  },
  ecpmColumn,
]

export const reportsUserStaticsHourlyAllColumn = [
  {
    name: 'historyHour',
    header: '시간',
    type: 'number',
    render: ({value}) => String(value).padStart(2, '0'),
  },
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="request">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="exposure">{decimalFormat(value)}</MetricValue>
  },
  //{name: 'validClickCount', header: '클릭수',type: 'number', render: ({value}) => <span>{decimalFormat(value)}</span>},
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <MetricValue $metric="revenue" className="won">{formatRevenue(value)}</MetricValue>
  },
  ecpmColumn,
]
/* 일자별보고서 컬럼 */
export const reportsStaticsHourlyAllColumn = [
  {
    name: 'historyHour',
    header: '시간',
    type: 'number',
    render: ({value}) => String(value).padStart(2, '0'),
  },
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="request">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <MetricValue $metric="exposure">{decimalFormat(value)}</MetricValue>
  },
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <MetricValue $metric="revenue" className="won">{formatRevenue(value)}</MetricValue>
  },
  ecpmColumn,
]

/* 일자별보고서 결과 리스트 */
export const reportsStaticsAll = atom([])
